import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

import { AngularFireAuth } from "angularfire2/auth";

import { NgxStarsModule } from "ngx-stars";

import { AngularMyDatePickerModule } from "angular-mydatepicker";

import { NgxCurrencyModule } from "ngx-currency";

export const currencyMask = {
  align: "right",
  allowNegative: true,
  allowZero: true,
  decimal: ",",
  precision: 2,
  prefix: "R$ ",
  suffix: "",
  thousands: ".",
  nullable: true,
};

import {
  MenuComponent,
  AuthGuard,
  HeaderComponent,
  UserMenuDirective,
  FilterComponent,
  ListComponent,
  PaginationComponent,
  FilterMenuDirective,
  CurrencyFormatPipe,
  NewComponent,
  ModelsSelectComponent,
  CheckboxComponent,
  RegionsStatesComponent,
  MaintenanceEquipmentsComponent,
  StoresComponent,
  RelatedEquipmentsComponent,
  AutocompleteComponent,
  HighlightPipe,
  EmptyResponsePipe,
  LoadingComponent,
  ValidatorHelper,
} from "./";

@NgModule({
  declarations: [
    MenuComponent,
    HeaderComponent,
    UserMenuDirective,
    FilterComponent,
    ListComponent,
    PaginationComponent,
    FilterMenuDirective,
    CurrencyFormatPipe,
    NewComponent,
    ModelsSelectComponent,
    CheckboxComponent,
    RegionsStatesComponent,
    MaintenanceEquipmentsComponent,
    StoresComponent,
    RelatedEquipmentsComponent,
    AutocompleteComponent,
    HighlightPipe,
    EmptyResponsePipe,
    LoadingComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    NgxCurrencyModule.forRoot(currencyMask),
    NgxStarsModule,
    AngularMyDatePickerModule,
    ReactiveFormsModule,
  ],
  providers: [AngularFireAuth, AuthGuard, ValidatorHelper],
  exports: [
    MenuComponent,
    HeaderComponent,
    UserMenuDirective,
    FilterComponent,
    ListComponent,
    PaginationComponent,
    FilterMenuDirective,
    CurrencyFormatPipe,
    NewComponent,
    ModelsSelectComponent,
    CheckboxComponent,
    RegionsStatesComponent,
    MaintenanceEquipmentsComponent,
    StoresComponent,
    RelatedEquipmentsComponent,
    AutocompleteComponent,
    HighlightPipe,
    EmptyResponsePipe,
    NgxStarsModule,
    LoadingComponent,
  ],
})
export class SharedModule {}
